/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { size } = typography.size ? typography : { size: {} };
const { text, transparent } = colors;

const textButton = {
  styleOverrides: {
    root: {
      minHeight: pxToRem(37),
      padding: `${pxToRem(9)} ${pxToRem(24)}`,
      fontSize: size?.sm || pxToRem(14),
      fontWeight: 500,
      textTransform: "uppercase",
      lineHeight: 1.5,
      color: text.main,
      backgroundColor: transparent.main,

      "&:hover": {
        backgroundColor: transparent.main,
      },

      "&:disabled": {
        color: text.disabled,
      },
    },
  },
};

export default textButton;
